import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Icon, IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { TableListView } from '@thoughtspot/radiant-react/widgets/table/table-list-view';
import { CellType, } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { EmptyCell } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/empty-cell/empty-cell';
import React from 'react';
import styles from '../backup-storage.module.scss';
import { NasStatus, SnapshotStatus } from './constants';
export const TableListWrapperComponent = ({ rowData, typeName, updateTable }) => {
    const { t } = useTranslation();
    const defaultOptions = {
        hasCheckboxes: false,
    };
    const nasColumnDefs = [
        {
            headerName: t('nas.modal.mountTitle'),
            colId: 'nasMountType',
            flex: 2,
            sortable: false,
            cellRendererFramework: (params) => (React.createElement(EmptyCell, { ...params }, (cellValues) => (React.createElement("div", { className: styles.upperCase }, cellValues.text)))),
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t('nas.modal.serverAddress'),
            colId: 'nasIpLink',
            field: 'link',
            flex: 2,
            sortable: false,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t('nas.modal.pathOnServer'),
            colId: 'serverPath',
            flex: 2,
            sortable: false,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t('nas.modal.localMountPoint'),
            colId: 'localMountPoint',
            flex: 2,
            sortable: false,
        },
        {
            cellRendererFramework: (params) => (React.createElement(EmptyCell, { ...params }, (cellValues) => (React.createElement("div", { className: cellValues.text === NasStatus.CONFIGURED
                    ? styles.configureSuccess
                    : cellValues.text ===
                        NasStatus.NOT_CONFIGURED
                        ? styles.configureInProgress
                        : styles.configureError },
                React.createElement(Icon, { id: cellValues.icon, color: cellValues.iconColor, size: cellValues.iconSize }),
                t(cellValues.text))))),
            headerName: t('configStatus.status'),
            colId: 'isConfiguredLogo',
            flex: 3,
            sortable: false,
        },
        {
            cellRendererFramework: (params) => (React.createElement(EmptyCell, { ...params }, (cellValues) => (React.createElement("div", { className: styles.deleteButton },
                React.createElement(Button, { icon: IconID.TRASH_CAN, type: "secondary", backgroundType: "light", onClick: cellValues.nasRowDeleteFunction, iconPlacement: "right" }))))),
            colId: 'deleteAction',
            flex: 1,
            sortable: false,
        },
    ];
    const snapShotColumnsDefs = [
        {
            cellRenderer: CellType[CellType.text],
            headerName: t('snapshot.modal.snapshotName.title'),
            colId: 'snapShotName',
            flex: 2,
            sortable: false,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t('system.backupStorage.snapshot.createdOn'),
            colId: 'snapShotScheduledOn',
            flex: 2,
            sortable: false,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t('system.backupStorage.snapshot.type'),
            colId: 'snapshotType',
            flex: 2,
            sortable: false,
        },
        {
            cellRendererFramework: (params) => (React.createElement(EmptyCell, { ...params }, ({ icon, iconSize, iconColor, text }) => {
                let className;
                switch (text) {
                    case SnapshotStatus.SNAPSHOT_CREATE_FINISHED:
                        className = styles.configureSuccess;
                        break;
                    case SnapshotStatus.SNAPSHOT_CREATE_STARTED:
                        className = styles.configureInProgress;
                        break;
                    case SnapshotStatus.SNAPSHOT_DELETE_SCHEDULED:
                        className = styles.configureInProgress;
                        break;
                    case SnapshotStatus.SNAPSHOT_CREATE_FAILED:
                        className = styles.configureError;
                        break;
                    case SnapshotStatus.SNAPSHOT_DELETE_FAILED:
                        className = styles.configureError;
                        break;
                    default:
                        className = '';
                }
                return (React.createElement("div", { className: className },
                    React.createElement(Icon, { id: icon, size: iconSize, color: iconColor, className: styles.statusIcon }),
                    t(text)));
            })),
            headerName: t('configStatus.status'),
            colId: 'snapshotStatus',
            flex: 2,
            sortable: false,
        },
        {
            cellRendererFramework: (params) => (React.createElement(EmptyCell, { ...params }, (cellValues) => (React.createElement("div", { className: styles.deleteButton },
                React.createElement(Button, { icon: IconID.TRASH_CAN, type: "secondary", id: cellValues.deleteKey, onClick: cellValues.rowDeleteFunction, "data-testid": "deleteSnapshotIcon" }))))),
            colId: 'deleteAction',
            flex: 1,
            sortable: false,
        },
    ];
    const nasColumns = [...nasColumnDefs];
    return (updateTable && (React.createElement(TableListView, { data: rowData, options: defaultOptions, columns: typeName === 'NAS' ? nasColumns : snapShotColumnsDefs, loading: false, "data-testid": `backupTable${typeName}` })));
};
//# sourceMappingURL=table-list-wrapper.js.map